{
  "de": {
    "milestone_unit": {
      "actions": {
        "change_milestone": "Meilenstein ändern",
        "reset_columns": "Spalten zurücksetzen"
      },
      "labels": {
        "columns": "Spalten",
        "milestone": "Bitte wählen Sie einen neuen Meilenstein aus",
        "no_results": "Keine Einheiten gefunden"
      }
    }
  }
}
